export default {
  'connections.title': 'Conexiones',
  'connectionGroup.title': 'Grupos de Conexiones',

  'connections.tabs.general': 'Generales',
  'connections.tabs.configurations': 'Configuraciones',

  'connections.type.azuregraph': 'Azure Graph',
  'connections.type.openai': 'OpenAI',
  'connections.type.google': 'Google',
  'connections.type.api': 'Api',
  'connections.type.database': 'Database',
  'connections.type.azuregraphsharepoint': 'Azure Graph SharePoint',
  'connections.type.ftp': 'Ftp',
  'connections.type.linkedin': 'LinkedIn',
  'connections.type.whatsappbusiness': 'WhatsApp Business',
  'connections.type.sendgrid': 'SendGrid',
  'connections.type.modelcontextprotocol': 'MCP',
  'connections.type.metapages': 'Meta Pages',

  'connections.azuregraph.credentialType': 'Tipo de Credencial',
  'connections.azuregraph.credentialType.appregistration': 'Registro de Aplicación',
  'connections.azuregraph.credentialType.platformoauth': 'Usuario OAuth (Microsoft Consent)',
  'connections.azuregraph.credentialType.unspecified': 'Sin especificar',
  'connections.azuregraph.userEmail': 'Correo del Usuario Conectado',
  'connections.azuregraph.userEmail.help':
    'Se completará automáticamente al autorizar la conexión con Microsoft.',
  'connections.azuregraph.userName': 'Usuario',
  'connections.azuregraph.password': 'Contraseña',
  'connections.azuregraph.clientId': 'Id del Cliente',
  'connections.azuregraph.tenantId': 'Id del Tenant',
  'connections.azuregraph.secret': 'Secret',
  'connections.azuregraph.secretExpiration': 'Fecha de Expiración del Secret',
  'connections.azuregraph.userId': 'ID de Usuario',
  'connections.azuregraph.userDisplayName': 'Nombre para Mostrar',
  'connections.azuregraph.tokenType': 'Tipo de Token',
  'connections.azuregraph.accessToken': 'Token de Acceso',
  'connections.azuregraph.accessTokenExpiration': 'Expiración del Token de Acceso',
  'connections.azuregraph.refreshToken': 'Token de Renovación',

  'connections.openai.apiKey': 'Clave Api',
  'connections.openai.organizationKey': 'Clave de Organización',

  'connections.google.credentialType': 'Tipo de Credencial',
  'connections.google.credentialType.serviceaccount': 'Cuenta de Servicio',
  'connections.google.credentialType.oauthuser': 'Usuario OAuth (Google Consent)',
  'connections.google.credentialType.unspecified': 'Sin especificar',
  'connections.google.userEmail': 'Correo del Usuario Conectado',
  'connections.google.userEmail.help':
    'Se completará automáticamente al autorizar la conexión con Google.',
  'connections.google.oauthRefreshToken': 'Token de Renovación OAuth',
  'connections.google.oauthAccessToken': 'Token de Acceso OAuth',
  'connections.google.oauthAccessTokenExpirationUtc': 'Expiración del Token de Acceso (UTC)',
  'connections.google.type': 'Tipo',
  'connections.google.projectId': 'ID del Proyecto',
  'connections.google.privateKeyId': 'ID de la Clave Privada',
  'connections.google.privateKey': 'Clave Privada',
  'connections.google.clientEmail': 'Correo del Cliente',
  'connections.google.clientId': 'Id del Cliente',
  'connections.google.authUri': 'URI de Autenticación',
  'connections.google.tokenUri': 'URI del Token',
  'connections.google.authProviderX509CertUrl': 'URL del Certificado X509 del Proveedor',
  'connections.google.clientX509CertUrl': 'URL del Certificado X509 del Cliente',
  'connections.google.universeDomain': 'Dominio Universal',

  'connections.api.method': 'Método',
  'connections.api.method.post': 'Post',
  'connections.api.method.get': 'Get',
  'connections.api.method.put': 'Put',
  'connections.api.method.delete': 'Delete',
  'connections.api.method.patch': 'Patch',
  'connections.api.authorizationType': 'Tipo de Autorización',
  'connections.api.authorizationType.noauth': 'Sin Autenticación',
  'connections.api.authorizationType.apikeyinheader': 'API Key - En Cabecera',
  'connections.api.authorizationType.apikeyinqueryparameters': 'API Key - En Url',
  'connections.api.authorizationType.bearertoken': 'Token Bearer',
  'connections.api.authorizationType.basicauth': 'Autenticación Básica',
  'connections.api.authorizationType.oauth': 'OAuth',
  'connections.api.authorizationType.automyonbehalfjwt': 'JWT firmado por AUTOMY',
  'connections.api.url': 'URL',
  'connections.api.resultContainerPropertyName': 'Nombre del Campo con los Resultados',
  'connections.api.codePropertyName': 'Nombre de Campo Código',
  'connections.api.searchValuePropertyName': 'Nombre de Campo Para Búsqueda',
  'connections.api.searchParameterPropertyName': 'Nombre de Parámetro de Búsqueda',
  'connections.api.displayTextPropertyName': 'Nombre de Campo a Mostrar',
  'connections.api.keyName': 'Nombre de Clave',
  'connections.api.keyValue': 'Valor de Clave',
  'connections.api.token': 'Token',
  'connections.api.username': 'Usuario',
  'connections.api.password': 'Contraseña',
  'connections.api.oAuthConnection': 'Conexión OAuth',
  'connections.api.oAuthConnectionId': 'ID de la Conexión OAuth',
  'connections.api.oAuthTokenResponsePropertyPosition': 'Posición del token en la respuesta',
  'connections.api.oAuthTokenResponsePropertyName':
    'Nombre de la propiedad del token en la respuesta',
  'connections.api.oAuthJsonBody': 'Cuerpo JSON',
  'connections.api.oAuthTokenSendPropertyPosition': 'Posición del token en el envío',
  'connections.api.oAuthTokenSendPropertyName': 'Nombre de la propiedad del token en el envío',
  'connections.api.subjectClaim': 'Identificador del usuario',
  'connections.api.audienceClaim': 'Destinatario del servicio',
  'connections.api.additionalClaims': 'Datos adicionales',

  'connections.api.codeField': 'Nombre de Campo Código',
  'connections.api.showField': 'Nombre de Campo a Mostrar',
  'connections.api.resultContainerPropertyName': 'Nombre de Campo con los Resultados',
  'connections.api.displayTextPropertyName': 'Nombre del Campo para Búsqueda',
  'connections.api.codePropertyName': 'Nombre de Campo Código',
  'connections.api.isSharedForAllInCompany': 'Compartida con toda la empresa',
  'connections.apiHeader': 'Api Header',
  'connections.apiHeader.key-exits': 'LLave Existe',
  'connections.api.webApiConnectionGroup': 'Grupo',

  'connections.api.position.header': 'Cabecera',
  'connections.api.position.url': 'Url',
  'connections.api.position.formdata': 'Formulario',
  'connections.api.position.bodyjson': 'Cuerpo(JSON)',
  'connections.api.position.xwwwformurlencoded': 'Formulario Url Codificada',
  'connections.api.position.authorization': 'Autorización',
  'connections.api.position.bodytext': 'Cuerpo(Texto)',
  'connections.api.position.formfiledata': 'Formulario / Fichero',
  'connections.api.confidential': 'Confidencial',
  'connections.api.notConfidential': 'No Confidencial',

  'connections.api.title': 'Configurar Conexiones APIs',
  'connections.api.address': 'Dirección URL',

  'connections.database.databaseType': 'Tipo',
  'connections.database.database': 'Nombre',
  'connections.database.host': 'Host',
  'connections.database.port': 'Puerto',
  'connections.database.username': 'Usuario',
  'connections.database.password': 'Contraseña',
  'connections.database.query': 'Consulta',

  'connections.database.databaseType.sqlserver': 'SQL Server',
  'connections.database.databaseType.access': 'Access',
  'connections.database.databaseType.mysql': 'MySQL',

  'connections.azuregraphsharepoint.sharePointCompanyUrl': 'Url de la empresa',
  'connections.azuregraphsharepoint.userName': 'Nombre de usuario',
  'connections.azuregraphsharepoint.password': 'Contraseña',
  'connections.azuregraphsharepoint.clientId': 'Id del cliente',
  'connections.azuregraphsharepoint.clientSecret': 'Clave del cliente',
  'connections.azuregraphsharepoint.authorityUrl': 'Url de autorización',

  'connections.ftp.transferType': 'Tipo de Transferencia',
  'connections.ftp.host': 'Host',
  'connections.ftp.userName': 'Nombre de Usuario',
  'connections.ftp.authenticationMode': 'Modo de Autenticación',
  'connections.ftp.password': 'Contraseña',
  'connections.ftp.privateKeyFile': 'Archivo de Clave Privada',
  'connections.ftp.authenticationMode.password': 'Contraseña',
  'connections.ftp.authenticationMode.privatekeyfile': 'Archivo de Clave Privada',

  'connections.linkedin.clientId': 'Id del Cliente',
  'connections.linkedin.clientSecret': 'Clave del Cliente',

  'connections.whatsappbusiness.phoneNumberId': 'ID del Número de Teléfono',
  'connections.whatsappbusiness.displayPhoneNumber': 'Número de Teléfono de Visualización',
  'connections.whatsappbusiness.whatsAppBusinessAccountId': 'ID de la Cuenta de WhatsApp Business',
  'connections.whatsappbusiness.appId': 'ID de la Aplicación',
  'connections.whatsappbusiness.webhookVerifyToken': 'Token de Verificación del Webhook',
  'connections.whatsappbusiness.accessToken': 'Token de Acceso',

  'connections.sendgrid.apiKey': 'Clave Api',
  'connections.sendgrid.ipPoolName': 'Nombre del pool de IP',
  'connections.sendgrid.emails': 'Correos',
  'connections.sendgrid.webhookEventVerificationKey':
    'Clave de Verificación de Eventos del Webhook',
  'connections.sendgrid.webhookInboundParserEventVerificationKey':
    'Clave de Verificación de Eventos del Analizador Entrante de Webhook',
  'connections.sendgrid.emailValidation': 'Validación de Correos',
  'connections.sendgrid.emailValidationApiKey': 'Clave API de validación de correos',

  'connections.modelcontextprotocol.serverName': 'Servidor',
  'connections.modelcontextprotocol.packageName': 'Nombre del Paquete',
  'connections.modelcontextprotocol.packageVersion': 'Versión del Paquete',
  'connections.modelcontextprotocol.launchMode': 'Modo de Lanzamiento',
  'connections.modelcontextprotocol.launchMode.remote': 'Remoto',
  'connections.modelcontextprotocol.launchMode.localprocess': 'Proceso Local',
  'connections.modelcontextprotocol.endpoint': 'Endpoint',
  'connections.modelcontextprotocol.transport': 'Transporte',
  'connections.modelcontextprotocol.transport.stdio': 'STDIO',
  'connections.modelcontextprotocol.transport.http': 'HTTP',
  'connections.modelcontextprotocol.localPort': 'Puerto Local',
  'connections.modelcontextprotocol.command': 'Comando',
  'connections.modelcontextprotocol.arguments': 'Argumentos',
  'connections.modelcontextprotocol.arguments.argument': 'Argumento',
  'connections.modelcontextprotocol.workingDirectory': 'Directorio de Trabajo',
  'connections.modelcontextprotocol.environment': 'Variables de Entorno',
  'connections.modelcontextprotocol.environment.variable': 'Variable',
  'connections.modelcontextprotocol.authorizationType': 'Tipo de Autorización',
  'connections.type.smtp': 'SMTP',
  'connections.type.twilio': 'Twilio',
  'connections.type.sendblue': 'Sendblue',

  'connections.sendblue.apiKeyId': 'Id de clave API',

  'connections.twilio.accountSid': 'Account SID',
  'connections.twilio.apiKeySid': 'API Key SID',
  'connections.smtp.fromName': 'Nombre Remitente',
  'connections.smtp.fromEmail': 'Correo Remitente',
  'connections.smtp.host': 'Host',
  'connections.smtp.port': 'Puerto',
  'connections.smtp.enableSSL': 'Habilitar SSL',
  'connections.smtp.username': 'Usuario',
  'connections.smtp.password': 'Contraseña',
  'connections.modelcontextprotocol.authorizationType.noauth': 'Sin Autenticación',
  'connections.modelcontextprotocol.authorizationType.automyonbehalfjwt': 'Automy On Behalf Jwt',
  'connections.modelcontextprotocol.additionalAgentInstructions':
    'Instrucciones Adicionales del Agente',
  'connections.modelcontextprotocol.additionalAgentInstructions.edit':
    'Editar Instrucciones Adicionales del Agente',
  'connections.modelcontextprotocol.additionalAgentInstructions.placeholder':
    'Ingrese instrucciones adicionales para el agente...',
  'connections.modelcontextprotocol.additionalAgentVectors': 'Vectores Adicionales del Agente',

  'connections.metapages.businessAccountId': 'ID de Cuenta de Negocio',
  'connections.metapages.appId': 'ID de Aplicación',
  'connections.metapages.appSecret': 'Secreto de Aplicación',
  'connections.metapages.accessToken': 'Token de Acceso',
  'connections.metapages.webhookVerifyToken': 'Token de Verificación del Webhook',

  'connections.databases.title': 'Gestionar Conexiones Bases de Datos',

  'connections.text.ownerUser': 'Propietario',
  'connections.text.validated': 'Validada',
  'connections.text.permissions': 'Permisos',
  'connections.text.scopes': 'Scopes',
  'connections.text.allowedOperations': 'Operaciones permitidas',

  'connections.operations.azureGraph.calendarFindMeetingTimes':
    'Calendario / Buscar horarios disponibles',
  'connections.operations.azureGraph.calendarCreateMeeting': 'Calendario / Crear reunión',
  'connections.operations.azureGraph.calendarDeleteMeeting': 'Calendario / Eliminar reunión',
  'connections.operations.azureGraph.emailGetMessage': 'Correo / Obtener mensaje',
  'connections.operations.azureGraph.emailSubscribeNewMessages':
    'Correo / Suscribirse a mensajes nuevos',

  'connections.operations.google.driveUploadFile': 'Drive / Subir archivo',
  'connections.operations.google.driveDownloadFile': 'Drive / Descargar archivo',
  'connections.operations.google.gmailListMessages': 'Correo / Listar mensajes (Gmail)',
  'connections.operations.google.gmailGetMessage': 'Correo / Obtener mensaje (Gmail)',
  'connections.operations.google.gmailSendMessage': 'Correo / Enviar mensaje (Gmail)',
  'connections.operations.google.calendarFindMeetingTimes':
    'Calendario / Consultar disponibilidad (Google Calendar)',
  'connections.operations.google.calendarCreateMeeting':
    'Calendario / Crear reunión (Google Calendar)',
  'connections.operations.google.calendarDeleteMeeting':
    'Calendario / Eliminar reunión (Google Calendar)',
  'connections.text.server': 'Servidor',
  'connections.text.validateAfterSave': 'Validar',
  'connections.text.groups': 'Grupos de Conexiones',

  'connections.callback.redirecting': 'Redirigiendo a la lista de conexiones...',
};
